export const MOODS = {
  sad: {
    title: "Felling Sad",
    breathe: "Breathe slowly",
    cardBg: "mood-bg-sad",
    glow: "mood-glow-sad",
    textColor: "text-sad",
  },
  focused: {
    title: "Stay Focused",
    breathe: "Deep focus",
    cardBg: "mood-bg-focused",
    glow: "mood-glow-focused",
    textColor: "text-focused",
  },
  energetic: {
    title: "Full of Energy",
    breathe: "Let’s go",
    cardBg: "mood-bg-energetic",
    glow: "mood-glow-energetic",
    textColor: "text-energetic",
  },
};
